import {useContext, useState, SetStateAction} from "react";
import {StoreContext} from "../../../stores/StoreLoader";
import styles from "./Microsite.module.scss";
import {EditableTitle} from "../../misc/Breadcrumbs";
import FontAwesome from "../../utilities/FontAwesome";
import ClickableLink from "../../utilities/ClickableLink";
import {IMicrositeLink} from "./Microsite";
import classNames from 'classnames';
import {DraggableMicrositeNavigation} from "./DraggableMicrositeNavigation";

export function MicrositeNavigation(props: {
    link: IMicrositeLink,
    micrositeOpen: boolean,
    setMicrositeOpen: SetStateAction<any>,
    reorder: boolean,
    index: number,
    isDragging?: boolean,
}) {
    const {organizationStore} = useContext(StoreContext);
    const [isDragging, setIsDragging] = useState(false);

    function handleClick() {
        if (props.micrositeOpen) {
            props.setMicrositeOpen(false);
        }
    }

    const linkIsCurrentPage = props.link.model?.id === organizationStore.currentOrganization.id;

    const linkClassName = classNames({
        [styles.link]: true,
        [styles.linkIsCurrentPage]: linkIsCurrentPage,
        [styles.linkReordering]: props.reorder,
        [styles.linkDragging]: isDragging,
    })

    let content;
    if (props.reorder) {
        content = <DraggableMicrositeNavigation
            link={props.link}
            index={props.index}
            isDragging={props.isDragging}
            setIsDragging={setIsDragging}
        />
    } else if (linkIsCurrentPage) {
        content = <span>
            <EditableTitle breadcrumb={props.link} hasMicrosite={true} editable={true}/>
            <FontAwesome name={'fa-angle-double-right'} prefix={'fas'}/>
        </span>
    } else {
        content = <ClickableLink
            href={props.link.url}
            onClick={handleClick}
        >
            <span>{props.link.label}</span>
            <FontAwesome name={'fa-angle-double-right'} prefix={'fas'}/>
        </ClickableLink>
    }

    return <>
        <li className={linkClassName}>
            {content}
            {props.link.children?.length > 0 && <ul>
                {props.link.children.map((link, index) => <MicrositeNavigation
                    reorder={props.reorder}
                    key={link.id}
                    link={link}
                    index={index}
                    micrositeOpen={props.micrositeOpen}
                    setMicrositeOpen={props.setMicrositeOpen}
                    isDragging={isDragging}
                />)}
            </ul>}
        </li>
        {props.link.children?.length > 0 && <span style={{display: "none"}}/>}</>
}